import { render } from "./list_soal.vue?vue&type=template&id=a88f753a&scoped=true"
import script from "./list_soal.vue?vue&type=script&lang=js"
export * from "./list_soal.vue?vue&type=script&lang=js"

import "./list_soal.vue?vue&type=style&index=0&id=a88f753a&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a88f753a"]])

export default __exports__